import styled from 'styled-components';

// Mobile-specific styled components for RingilDataTable
export const MobileCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  min-height: 120px;
`;

export const MobileCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;

  /* Ensure the left side (checkbox + link) stays together */
  > div:first-child {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  /* Ensure the right side (ExpeditionStateSpan) is pushed to the right */
  > *:last-child {
    margin-left: auto;
    flex-shrink: 0;
  }
`;

export const MobileCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 40px; /* Space for checkbox */
`;

export const MobileSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MobileSectionTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 4px;
`;

export const MobileInfoTag = styled.div<{ backgroundColor?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 4px 8px;
  background-color: ${props => props.backgroundColor || 'transparent'};
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 12px;
  margin-right: 8px;
  margin-bottom: 4px;
  word-break: break-word;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    fill: #6b7280;
  }

  .tag-label {
    color: #6b7280;
    font-weight: 400;
  }

  .tag-text {
    color: #374151;
    font-weight: 500;
  }
`;

export const MobileFileTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 4px 8px;
  background-color: #fef7f0;
  border: 1px solid #fed7aa;
  border-radius: 6px;
  font-size: 12px;
  margin-right: 8px;
  margin-bottom: 4px;
  cursor: pointer;
  color: #ea580c;

  &:hover {
    background-color: #fef3e9;
  }

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    fill: #ea580c;
  }
`;

export const MobileLabelDiv = styled.div<{ color: string }>`
  display: inline-block;
  background-color: ${props => props.color};
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 4px;
  margin-bottom: 4px;
`;
